import PropTypes from 'prop-types';
import styles from './FJTextToImageResolution.module.less';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import { useCallback, useMemo, useState } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import CheckIcon from '../../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import FJConstant from '../../../../constants/FJConstant.js';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';

const textInfo = {
    low: 'low-footer',
    medium: 'medium-footer',
    high: 'high-footer',
};

const FJTextToImageResolution = ({
    curResolution,
    changeResolution,
    curModelObj,
    boxStyle,
    type,
    placement = 'rightTop',
    offsetLeft = 20,
    offsetTop = -21,
}) => {
    const [showSideModel, setShowSideModel] = useState(false);

    const handleOnMouseDown = useCallback(
        e => {
            showSideModel && e.stopPropagation();
        },
        [showSideModel],
    );

    const handleChangeResolution = useCallback(
        resolution => {
            changeResolution(resolution.value);
        },
        [changeResolution],
    );

    const supportResolutions = useMemo(() => {
        if (!curModelObj?.supportResolutions) {
            return null;
        }
        return curModelObj?.supportResolutions;
    }, [curModelObj]);

    const curResolutionObj = useMemo(() => {
        return supportResolutions?.find(item => item.value === curResolution);
    }, [curResolution, supportResolutions]);

    const supportResolutionsTitle = useMemo(() => {
        return curModelObj?.supportResolutionsTitle || 'resolution';
    }, [curModelObj]);

    if (!supportResolutions) {
        return null;
    }
    const _renderTrigger = ({ ref, onClick }) => {
        if (type === FJConstant.FOOTER) {
            return (
                <FJToolTip title={supportResolutionsTitle}>
                    <div className={styles.icon_box} ref={ref} onClick={onClick}>
                        {curResolutionObj?.name.includes('<')
                            ? curResolutionObj?.shortName
                            : FJLocalStore._(textInfo[curResolutionObj?.name])}
                    </div>
                </FJToolTip>
            );
        }
        return (
            <div className={styles.resolution_btu} onClick={onClick} onMouseDown={handleOnMouseDown} ref={ref}>
                {curResolutionObj?.name.includes('<') ? (
                    <div
                        className={styles.resolution_btu_name}
                        dangerouslySetInnerHTML={{ __html: curResolutionObj?.name }}
                    />
                ) : (
                    <div className={styles.resolution_btu_name}>{FJLocalStore._(curResolutionObj?.name)}</div>
                )}
                <ArrowIcon className={classNames(styles.arrow_icon, { [styles.arrow_icon_active]: showSideModel })} />
            </div>
        );
    };

    const _renderOverlay = ({ ref }) => {
        return (
            <div className={styles.resolution_side_model} ref={ref}>
                <div className={styles.model_resolution_title}>{FJLocalStore._(supportResolutionsTitle)}</div>

                <FJVerticalScroller className={styles.resolution_list_box}>
                    {supportResolutions.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.resolution_item,
                                    item.value === curResolution && styles.resolution_item_active,
                                )}
                                key={item.value}
                                onClick={() => handleChangeResolution(item)}
                            >
                                {item.name.includes('<') ? (
                                    <div
                                        className={styles.resolution_item_name}
                                        dangerouslySetInnerHTML={{ __html: item.name }}
                                    ></div>
                                ) : (
                                    <div className={styles.resolution_item_name}>{FJLocalStore._(item.name)}</div>
                                )}
                                {item.value === curResolution && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </div>
        );
    };

    return (
        <>
            {type === FJConstant.FOOTER ? (
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    renderOverlay={_renderOverlay}
                    offsetLeft={offsetLeft}
                    offsetTop={offsetTop}
                    zIndex={999}
                    trigger='click'
                    placement={placement}
                    useAnchorBody
                    canTriggerActive
                    onHide={() => setShowSideModel(false)}
                    onShow={() => setShowSideModel(true)}
                    ignoreManager={false}
                />
            ) : (
                <div className={styles.resolution_box} style={boxStyle}>
                    <div className={styles.resolution_title}>{FJLocalStore._(supportResolutionsTitle)}</div>
                    <FJDropdownNew
                        renderTrigger={_renderTrigger}
                        renderOverlay={_renderOverlay}
                        offsetLeft={offsetLeft}
                        offsetTop={offsetTop}
                        zIndex={999}
                        trigger='click'
                        placement={placement}
                        useAnchorBody
                        canTriggerActive
                        onHide={() => setShowSideModel(false)}
                        onShow={() => setShowSideModel(true)}
                        ignoreManager={false}
                    />
                </div>
            )}
        </>
    );
};

FJTextToImageResolution.propTypes = {
    curResolution: PropTypes.string,
    changeResolution: PropTypes.func,
    curModelObj: PropTypes.object,
    boxStyle: PropTypes.object,
};

export default FJTextToImageResolution;
